import ILookupModel from "types/backend_models/lookup_status/ILookupModel";

export function formatLookupModal(lookupModels: ILookupModel[], lookupModelId: number, notFoundReturn = '/'): string {
	const lookupModel = lookupModels.find(lm => lm.id === lookupModelId);
	if (lookupModel) {
		return lookupModel.label;
	} else {
		return notFoundReturn
	}
}